import { AppRoutes } from '../../common/constants';
import { Box, Typography } from '@mui/material';
import { FNADetails } from '../../common/types/analyses';
import { JSX } from 'react';
import { QuoteItem } from '../../common/types/quotes';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import Content from '../../common/components/content';
import FnaPageHeaderSummary from '../components/fnaPageHeaderSummary';
import groupBy from 'lodash/groupBy';
import Layout from '../../common/components/layout';
import LayoutLoadingState from '../../common/components/layout/layoutLoadingState';
import Quotes from '../../quotes/quotes';

/**
 * Display FNA's quotes
 */
const FnaQuotesPage = (): JSX.Element => {
  const { id } = useParams();
  const { data: fna } = useQuery<FNADetails>({
    queryKey: [`/FNADetail/${id}`],
    enabled: Boolean(id),
  });

  const { data: quotes } = useQuery<QuoteItem[]>({
    queryKey: ['/FNAQuoteLists', { fnaID: id }],
  });

  const quotesByType = groupBy(quotes, 'typeNote');

  if (!fna) {
    return <LayoutLoadingState />;
  }

  const fnaRoleplayers =
    fna.roleplayers.map(({ roleplayerName }) => roleplayerName).join(', ') || '-';
  const breadcrumbs = [
    { label: 'Financial needs analyses', href: AppRoutes.FNAs },
    { label: fnaRoleplayers, href: `${AppRoutes.FNAs}/${fna.id}` },
    { label: 'Quotes', href: `${AppRoutes.FNAs}/${fna.id}/quotes` },
  ];

  return (
    <Layout breadcrumbs={breadcrumbs}>
      <Content>
        <Box className="md:flex justify-between items-end md:space-x-4 space-y-8 md:space-y-0">
          <FnaPageHeaderSummary fna={fna} />
        </Box>
        {Object.entries(quotesByType).map(([type, quotes]) => (
          <Box className="my-8" key={type}>
            <Box>
              <Typography variant="h6" fontWeight="bold">
                {quotes.length} {type} needs
              </Typography>
            </Box>
            <Quotes quotes={quotes} enableQuickFilter={false} />
          </Box>
        ))}
      </Content>
    </Layout>
  );
};
export default FnaQuotesPage;
